/* eslint no-console: ["error", { allow: ["warn", "log"] }] */
import tracker from '../../helpers/tracker';
import EventType from './types';

export interface EventsTrackerRepository {
  sendEvent: (type: EventType, payload?: any) => void;
}

export const useEventsTracker = (): EventsTrackerRepository => {
  const sendEvent = (type: EventType, payload: any = {}) => {
    try {
      tracker.event(type, payload);
    } catch (e) {
      console.log('Tracker', e.message);
    }
  };

  return {
    sendEvent,
  };
};
